<template>
  <div style="max-height: 250px;overflow-y: scroll;">
    <b-table
      responsive
      outlined
      :items="datos"
      :fields="fieldsBecas"
      class="mb-0"
      show-empty
      empty-text="Aun no cuenta con becas activas."
      :busy="showLoading"
    >
      <template #cell(descripcion)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>
      <!-- acepta seguir -->
      <template #cell(acepta_seguir)="row">
        <b-badge variant="light-primary">
          {{ (row.item.acepta_seguir === null) ? 'Sin Confirmar' : (row.item.acepta_seguir == 1) ? 'SI' : 'NO' }}
        </b-badge>
      </template>

      <template #table-busy>
        <div class="text-center text-warning my-2">
          <b-spinner class="align-middle" />
          <strong> Cargando...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable, BSpinner, BBadge } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { BecasAlumno } from './useKardex'

export default {
  components: {
    BTable,
    BSpinner,
    BBadge,
  },
  props: {
    datos: {
      type: Array,
      required: true,
    },
  },
  setup() {
    // const toast = useToast()
    const showLoading = ref(false)
    const becasList = ref(null)
    const fieldsBecas = ref([])

    fieldsBecas.value = [
      { key: 'agenda', sortable: true },
      { key: 'situacion' },
      { key: 'st_desc', label: 'descripcion' },
      { key: 'periodo', sortable: true },
      { key: 'clave' },
      { key: 'abrev' },
      { key: 'descripcion', label: 'Tipo de Beca' },
    ]

    return {
      // functions
    //   BecasxPersona,
      // values
      showLoading,
      becasList,
      fieldsBecas,
    }
  },
}
</script>
